import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { KEY } from '../../../../components/utils/stripeKey';
import AccountForm from './accountForm';
import styles from './bankAccount.module.scss';

const AccountDetail = () => {
  const stripePromise = loadStripe(KEY);

  return (
    <div className={styles.bankAccount}>
      <div className={styles.body}>
        <Elements stripe={stripePromise}>
          <AccountForm />
        </Elements>
      </div>
    </div>
  );
};

export default AccountDetail;
